import request from '@/utils/request'

//部门合并迁移（只有超级管理员能调）
export function deptMerge(data) {
  return request({
    method: 'post',
    url: '/yzdservice/api/ga/deptMerge/merge',
    data: data
  })
}
